import React from 'react';

// MMT-inspired hotel-result skeleton — 3-column shimmer mirroring the real card.
const SkeletonHotelCard = () => (
  <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-2xl overflow-hidden">
    <div className="flex flex-col md:flex-row">
      <div className="md:w-[260px] h-48 md:h-auto md:min-h-[200px] bg-gray-200 dark:bg-gray-800 shimmer" />
      <div className="flex-1 p-5 space-y-2.5">
        <div className="h-5 w-2/3 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
        <div className="h-3 w-1/2 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
        <div className="flex gap-1.5 pt-1">
          <div className="h-5 w-16 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
          <div className="h-5 w-16 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
          <div className="h-5 w-16 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
        </div>
        <div className="h-3 w-1/3 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
      </div>
      <div className="border-t md:border-t-0 md:border-l border-dashed border-gray-200 dark:border-gray-700 p-5 md:w-[200px] space-y-2.5">
        <div className="h-3 w-16 bg-gray-200 dark:bg-gray-800 rounded ml-auto shimmer" />
        <div className="h-6 w-24 bg-gray-200 dark:bg-gray-800 rounded ml-auto shimmer" />
        <div className="h-3 w-20 bg-gray-200 dark:bg-gray-800 rounded ml-auto shimmer" />
        <div className="h-9 w-full bg-red-100 dark:bg-red-900/40 rounded shimmer" />
      </div>
    </div>
  </div>
);

const SkeletonCard = () => (
  <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
    <div className="flex items-start gap-4">
      <div className="h-14 w-14 bg-gray-200 dark:bg-gray-800 rounded-lg shimmer" />
      <div className="flex-1 space-y-2">
        <div className="h-4 w-1/3 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
        <div className="h-3 w-1/4 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
      </div>
      <div className="space-y-2 text-right">
        <div className="h-5 w-24 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
        <div className="h-8 w-24 bg-red-200 dark:bg-red-900/40 rounded shimmer" />
      </div>
    </div>
    <div className="mt-4 grid grid-cols-3 gap-4">
      <div className="h-3 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
      <div className="h-3 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
      <div className="h-3 bg-gray-200 dark:bg-gray-800 rounded shimmer" />
    </div>
  </div>
);

const ResultsSkeleton = ({ count = 4, variant = 'generic' }) => (
  <div className="space-y-4" data-testid="results-skeleton">
    {Array.from({ length: count }).map((_, i) =>
      variant === 'hotel' ? <SkeletonHotelCard key={i} /> : <SkeletonCard key={i} />
    )}
  </div>
);

export default ResultsSkeleton;
